export default "__VITE_ASSET__CTpx32H9__"